import {AppState} from '../index';

export enum SubscriptionStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}

export interface Subscription {
  id: number;
  status: SubscriptionStatus;
  name: string;
  isCancelled: boolean;
  isGift: boolean;
  validTo: string;
  validToDays: number;
  price: number;
  priceInUah: boolean;
}

interface State {
  subscription: null | Subscription;
  promoFormOpened: boolean;
}

const initState: State = {
  subscription: null,
  promoFormOpened: false,
};

const FETCH_SUBSCRIPTION_INFO = '@subscription/info';
const PROMO_FORM_OPENED = '@subscription/promo-opened';

interface FetchSubscriptionInfo {
  type: typeof FETCH_SUBSCRIPTION_INFO;
  data: null | Subscription;
}

interface PromoFormOpened {
  type: typeof PROMO_FORM_OPENED;
  data: boolean;
}

export type SubscriptionAction =
  FetchSubscriptionInfo | PromoFormOpened;

export const subscriptionReducer = (
  state: State = initState,
  action: SubscriptionAction,
) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_INFO:
      return {
        ...state,
        subscription: action.data,
      };

    case PROMO_FORM_OPENED:
      return {
        ...state,
        promoFormOpened: action.data,
      };

    default:
      return state;
  }
};

export const setProSubscription = (subscription: null | Subscription) => {
  return {
    type: FETCH_SUBSCRIPTION_INFO,
    data: subscription,
  };
};

export const getProSubscription = (state: AppState) =>
  state.subscription.subscription;

export const setPromoFormOpened = (status: boolean) => {
  return {
    type: PROMO_FORM_OPENED,
    data: status,
  };
};

export const isPromoFormOpened = (state: AppState) =>
  state.subscription.promoFormOpened;
